import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { AuthService } from "src/app/core/service/auth.service";
import { LeaderboardDTO } from "src/app/data/schema/Gamification/Leaderboard/LeaderboardDTO";
import { LeaderboardFiltersDTO } from "src/app/data/schema/Gamification/Leaderboard/LeaderboardFiltersDTO";
import { RankingDTO } from "src/app/data/schema/Gamification/Ranking/RankingDTO";
import { RankingGroupingByTypeDTO } from "src/app/data/schema/Gamification/Ranking/RankingGroupingByTypeDTO";
import { GrupoTO } from "src/app/data/schema/User/GrupoTO";
import { ApiLeaderboardsService } from "src/app/data/service/gamification/api-leaderboards.service";
import { ApiRankingService } from "src/app/data/service/gamification/api-ranking.service";
import enUS from "./i18n/en-US.json";
import esES from "./i18n/es-ES.json";
import ptBR from "./i18n/pt-BR.json";

@Component({
    selector: "app-leaderboard",
    templateUrl: "./leaderboard.component.html",
    styleUrls: ["./leaderboard.component.scss"]
})
export class LeaderboardComponent implements OnInit {
    rankings: RankingDTO[];
    selectedRanking: RankingDTO;
    leaderboards: LeaderboardDTO[];
    leaderboardsPodium: LeaderboardDTO[];
    userLeaderboards: LeaderboardDTO[];
    groups: GrupoTO[];
    currentGroup: GrupoTO;

    constructor(
        private leaderboardService: ApiLeaderboardsService,
        private rankingsService: ApiRankingService,
        private spinner: NgxSpinnerService,
        private _translateService: TranslateService,
        private authService: AuthService
    ) {
        this._translateService.setTranslation("pt-BR", ptBR, true);
        this._translateService.setTranslation("en-US", enUS, true);
        this._translateService.setTranslation("es-ES", esES, true);
    }

    loadRankings(): void {
        this.spinner.show();

        this.rankingsService
            .list({ find: "", orderBy: "name", sortOrder: "asc", skip: 0, take: 100, active: true, valids: true })
            .subscribe(
                (res) => {
                    if (res.data.length == 0) return;

                    this.rankings = res.data;
                },
                () => {
                    this.spinner.hide();
                }
            );
    }

    loadLeaderboard(userId?: string): void {
        if (!this.selectedRanking) return;

        this.spinner.show();

        const filter: LeaderboardFiltersDTO = {
            find: null,
            orderBy: "",
            sortOrder: "asc",
            skip: 0,
            take: 10,
            rankingId: this.selectedRanking.id,
            userGroupIds: [this.currentGroup?.id] || null,
            showGroups: this.selectedRanking.settings.groupingByType == RankingGroupingByTypeDTO.Group,
            showUsers: this.selectedRanking.settings.groupingByType == RankingGroupingByTypeDTO.Individual,
            userId: userId
        };

        this.leaderboardService.Get(filter).subscribe(
            (res) => {
                if (!userId) {
                    this.leaderboards = res.data;

                    if (
                        this.leaderboards.length > 0 &&
                        !this.leaderboards.find((x) => x.userId == this.authService.getClaimsUserId()) &&
                        filter.showUsers
                    )
                        this.loadLeaderboard(this.authService.getClaimsUserId());

                    this.leaderboardsPodium = this.leaderboards?.splice(0, 3);
                } else this.userLeaderboards = res.data;

                this.spinner.hide();
            },
            () => {
                this.spinner.hide();
            }
        );
    }

    listGroups(): void {
        if (!this.selectedRanking?.settings?.groups || this.selectedRanking.settings.groups.length == 0) {
            this.groups = null;
            return;
        }

        this.groups = this.selectedRanking.settings.groups.filter((x) =>
            this.authService.getClaimsGroupIds()?.includes(x.id)
        );

        this.currentGroup = this.groups[0];
    }

    ngOnInit(): void {
        this.loadRankings();
    }

    changeSelectedRanking(i: number): void {
        this.selectedRanking = this.rankings[i];
        this.leaderboards = [];
        this.leaderboardsPodium = [];
        this.userLeaderboards = [];

        this.listGroups();
        this.loadLeaderboard();
    }
}
